<!--
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-05-25 14:50:05
 -->
<template>
    <div class="second-item-box">
      <template v-for="(child,index) in menuData">
        <el-submenu v-if="child.children.length > 0" :index="child.path">
          <template slot="title">
            <i :class="child.iconCls?child.iconCls:[fa,fa-file]"></i>
            <span slot="title">{{ $t(`routeName.${child.name}`) }}</span>
          </template>
          <menu-tree :menuData="child.children"></menu-tree>
        </el-submenu>

        <el-menu-item v-else-if="!child.hidden && !outMenu.includes(child.name)" :index="child.path">
          <!--<i :class="child.iconCls?child.iconCls:[fa,fa-file]"></i>-->
          <!--<i class="el-icon-caret-right i-cus"></i>-->
          <span class="sd"></span>
          <span slot="title">{{ $t(`routeName.${child.name}`) }}</span>
        </el-menu-item>
      </template>
    </div>
</template>

<script>
export default {
  name: 'menuTree',
  props: ['menuData'],
  data() {
      return {
        outMenu: ['checkcontract','copyContract','remind']
      }
  },
  mounted() {
  },
  methods:{
  }
}
</script>

<style lang="scss">
  .el-submenu .el-menu-item{padding: 0 10px 0 30px!important;}
  .sd{display:inline-block;width: 5px;margin:0 5px 0 20px;height: 5px;background:rgba(255,255,255,0.7);border-radius: 50%;}
  .el-menu-item i.i-cus{width: 18px!important;}
  .el-menu-item,.el-submenu__title{height: 40px!important;line-height: 40px!important;padding: 0 !important;}
  .second-item-box .el-menu-item{width:180px!important;min-width: 180px;}
</style>



// WEBPACK FOOTER //
// src/pages/layout/aside/menuTree.vue